import api from "../api";

const state = {
    headed: null
};

const getters =  {
    getHeaded(state){
      return state.headed;
    }
};

const mutations = {
    setHeaded: function(state, headed){
        state.headed = headed;
    }
};

const actions = {
    loadHeaded({commit}){
        return api.general.headed();
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};